import React from 'react';
import { discountBadgeClass, discountPercentLabel, priceDiscountPercent } from '../utils/priceDiscount';
import '../styles/product-discount-image.css';

const ProductDiscountImage = ({ price, discountedPrice, discountPercent, personalDiscount, productDiscount,
  className = '', as: Container = 'span', children, ...containerProps }) => {
  // Catalog administration exposes the configured percentage instead of a sale price.
  const percent = discountPercentLabel(discountPercent ?? priceDiscountPercent(price, discountedPrice));
  const colorClass = discountBadgeClass({ price, discountedPrice, personalDiscount, productDiscount: productDiscount ?? discountPercent });
  return <Container {...containerProps} className={`product-discount-image ${className}`.trim()}>
    {children}
    {percent && <span className={`product-image-discount ${colorClass}`} aria-label={`Знижка ${percent}%`}>−{percent}%</span>}
  </Container>;
};

export default ProductDiscountImage;
